// Module
var code = "<script>let $editFormOrganism</script> <molecule-panel-error error-type=\"update\" error-box-type=\"fixed\"></molecule-panel-error> <molecule-form-edit save=\"$editFormOrganism.save\"> <organ-edit-panel-webspace-users></organ-edit-panel-webspace-users> </molecule-form-edit> ";
// Exports
module.exports = code;